module.exports = __webpack_public_path__ + "img/ZJ5211.274414b8.png";